import switchStep from '../components/switchStep';
import {history, labels} from '../globals/config';
import {idgUrl} from '../../global/apiProxy';
import {restartVehicleSelect} from '../components/restarts';
import {vinModal} from '../../appointment-tool/modules/vehicleSelector';
import qtAnalytics, {handleImpressions} from '../components/qtAnalytics';
import analyticsErrors from '../components/analyticsErrors';

const $ = jQuery;
const $quoteToolContainer = $('#quote-tool');

/**
 * Vehicle selector data
 * @type {{chassisNumber: string, licensePlate: string, marques: string, model: string, mileage: string}}
 */
export let vehicleSelectorData = {
    marques: '',
    marqueText: '',
    model: '',
    modelText: '',
    chassisNumber: '',
    licensePlate: '',
    mileage: '',
};

export function vehicleSelectorModule() {
    submitVehicleSelector();
    vinModal();

    // Marque select
    $quoteToolContainer.on('change', 'select[name="marque"]', function () {
        getModuleData();
        restartVehicleSelect('marque');
        loadModels();
    });

    // Model select
    $quoteToolContainer.on('change', 'select[name="model"]', function () {
        getModuleData();
    });

    let $vinCheckbox = $quoteToolContainer.find('#qt-vehicle-select-vin-checkbox');

    if($vinCheckbox) {
        $vinCheckbox.on('change', function () {
            if ($(this).is(':checked')) {
                $quoteToolContainer.find('.js-vehicle-data').addClass('active');
            } else {
                $quoteToolContainer.find('.js-vehicle-data').removeClass('active');
            }
        });
    }
}

/**
 * Vehicle selector module
 */
function submitVehicleSelector() {
    $quoteToolContainer.on('click', '.js-qt-vehicle-select-submit', function () {
        if (validateVehicleSelect()) {
            getModuleData();
            setModuleData();
            switchStep('garage-locator');
            history.push('garage-locator');

            let vehicle = vehicleSelectorData.chassisNumber;
            if (!vehicle) {
                const marque = vehicleSelectorData.marqueText;
                const model = vehicleSelectorData.modelText;
                if (model.includes(marque)) {
                    vehicle = model;
                } else {
                    vehicle = `${marque} ${model}`;
                }
            }

            qtAnalytics('vehicle-info-submit', vehicle);
            qtAnalytics('dealer-start', '', 4.1);
            handleImpressions('dealer-impression');
        } else {
            $('.js-qt-vehicle-select-submit').removeClass('c-button--disabled');
        }
    });
}

/**
 * Get data from vehicle selector form
 */
function getModuleData() {
    let $moduleContainer = $('.c-qt-vehicle-select');

    vehicleSelectorData.marques = $moduleContainer.find('select[name="marque"]').val();
    vehicleSelectorData.marqueText = $moduleContainer.find('select[name="marque"] option:selected').text();
    vehicleSelectorData.model = $moduleContainer.find('select[name="model"]').val();
    vehicleSelectorData.modelText = $moduleContainer.find('select[name="model"] option:selected').text();
    vehicleSelectorData.chassisNumber = $moduleContainer.find('input#vin').val();
    vehicleSelectorData.licensePlate = $moduleContainer.find('input#license-plate').val();
    vehicleSelectorData.mileage = $moduleContainer.find('input#mileage').val();
}

/**
 * Set data to next step module
 */
function setModuleData() {
    let $nextStepModule = $('.c-qt-schedule');
    const marque = vehicleSelectorData.marqueText;
    const model = vehicleSelectorData.modelText;
    let vehicle;

    if (model.includes(marque)) {
        vehicle = model;
    } else {
        vehicle = `${marque} ${model}`;
    }

    $nextStepModule.find('.js-tool-sidebar--vehicle').text(vehicle);

    if (vehicleSelectorData.licensePlate) {
        $nextStepModule.find('.js-tool-sidebar--licence').text(vehicleSelectorData.licensePlate);
    }

    if (vehicleSelectorData.chassisNumber) {
        $nextStepModule.find('.js-tool-sidebar--vin').text(vehicleSelectorData.chassisNumber);
    }
}

/**
 * Load marques
 */
export function loadMarques() {
    const settings = {
        async: true,
        url: idgUrl('makes'),
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
    };

    $.ajax(settings).done(function (marques) {
        if (marques) {
            $('select[name="marque"]').append(`
					<option disabled selected></option>
				`);

            marques.forEach((marque) => {
                $('select[name="marque"]').append(`
					<option value="${marque.id}">${marque.label}</option>
				`);
            });
        } else {
            $('select[name="marque"]').append(`
				<option disabled selected>${labels.noMarques}</option>
			`);
        }

        $('.js-qt-vehicle-select-submit').removeClass('c-button--disabled');
    }).fail(function (error) {
        $('select[name="marque"]').append(`
				<option disabled selected>${labels.noMarques}</option>
			`);

        $('.js-qt-vehicle-select-submit').removeClass('c-button--disabled');

        analyticsErrors('vehicle-info', 4, 'system-error', error.statusText);
    });
}

/**
 * Load models
 */
function loadModels() {
    const settings = {
        async: true,
        url: idgUrl(`makes/${encodeURIComponent(vehicleSelectorData.marques)}/models`),
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
    };

    $.ajax(settings).done(function (models) {
        if (models) {
            const $modelSelect = $('select[name="model"]');

            $modelSelect.append(`
				<option disabled selected></option>
			`);

            models.forEach((model) => {
                $modelSelect.append(`
                    <option value="${model.id}">${model.label}</option>
                `);
            });

            $modelSelect.closest('label').removeClass('disabled');
            $('.js-qt-vehicle-select-submit').removeClass('c-button--disabled');
        }
    });
}

/**
 * Load versions
 */
function loadVersions() {
    const settings = {
        async: true,
        url: idgUrl(`models/${encodeURIComponent(vehicleSelectorData.marques)}/${encodeURIComponent(vehicleSelectorData.model)}/versions`),
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
    };


    $.ajax(settings).done(function (versions) {
        if (versions) {
            const $versionSelect = $('select[name="year"]');
            $versionSelect.append(`
				<option disabled selected></option>
			`);

            versions.forEach((version) => {
                $versionSelect.append(`
			        <option value="${version.id}">${version.label}</option>
			    `);
            });

            $versionSelect.closest('label').show(0);
            $('.js-qt-vehicle-select-submit').removeClass('c-button--disabled');
        }
    });
}

/**
 * Validate select fields for manual vehicle select.
 */
export function validateVehicleSelect() {
	const $vehicleSelectContainer = $('.c-qt-vehicle-select');

	let valid = true;
	let analyticsErrorTexts = [];

	const $vinCheckbox = $vehicleSelectContainer.find('#qt-vehicle-select-vin-checkbox');

	// Only validate marque & model if VIN checkbox is checked
	if ($vinCheckbox.is(':checked')) {
		checkValidation($vehicleSelectContainer.find('select[name="marque"]'), 'marque');
		checkValidation($vehicleSelectContainer.find('select[name="model"]'), 'model');
	}

	checkValidation($vehicleSelectContainer.find('input#license-plate'), 'licensePlate');
	checkValidation($vehicleSelectContainer.find('input#vin'), 'vin');
	checkValidation($vehicleSelectContainer.find('input#mileage'), 'mileage');

	function checkValidation($input, type) {
		const $parent = $input.parent();

		// Basic validations for marque, model, licensePlate
		if (type === 'marque' || type === 'model' || type === 'licensePlate') {
			if (!$input.val()) {
				if (!$parent.hasClass('error')) {
					$parent.addClass('error');
				}
				valid = false;
				if (type === 'marque') analyticsErrorTexts.push('Marque field can’t be empty.');
				if (type === 'model') analyticsErrorTexts.push('Model field can’t be empty.');
				if (type === 'licensePlate') analyticsErrorTexts.push('License plate field can’t be empty.');
			} else {
				$parent.removeClass('error');
			}
		}

		// VIN validations
		if (type === 'vin') {
			const $vinCheckbox = $vehicleSelectContainer.find('#qt-vehicle-select-vin-checkbox');
			const $vinCheckboxParent = $vinCheckbox.parent();
			if (!$input.val() && !$vinCheckbox.is(':checked')) {
				if (!$parent.hasClass('error')) {
					$parent.addClass('error');
				}
				if (!$vinCheckboxParent.hasClass('error')) {
					$vinCheckboxParent.addClass('error');
				}
				valid = false;
				analyticsErrorTexts.push('VIN field can’t be empty.');
			} else if (validateVin($input.val()) === false && !$vinCheckbox.is(':checked')) {
				if (!$parent.hasClass('error')) {
					$parent.addClass('error');
				}
				valid = false;
				analyticsErrorTexts.push('VIN number is not valid.');
			} else {
				$parent.removeClass('error');
				$vinCheckboxParent.removeClass('error');
			}
		}

		// Mileage validations
		if (type === 'mileage') {
			const $mileageCheckbox = $vehicleSelectContainer.find('#qt-vehicle-select-mileage-checkbox');
			const $mileageCheckboxParent = $mileageCheckbox.parent();
			if (!$input.val() && !$mileageCheckbox.is(':checked')) {
				if (!$parent.hasClass('error')) {
					$parent.addClass('error');
				}
				if (!$mileageCheckboxParent.hasClass('error')) {
					$mileageCheckboxParent.addClass('error');
				}
				valid = false;
				analyticsErrorTexts.push('Mileage field can’t be empty.');
			} else if (isNaN($input.val())) {
				if (!$parent.hasClass('error')) {
					$parent.addClass('error');
				}
				valid = false;
				analyticsErrorTexts.push('Mileage field must be a number.');
			} else {
				$parent.removeClass('error');
				$mileageCheckboxParent.removeClass('error');
			}
		}
	}

	// Track errors if any
	if (!valid) {
		analyticsErrorTexts = analyticsErrorTexts.join(' | ');
		analyticsErrors('vehicle-info', 4, 'user-error', '', analyticsErrorTexts);
		handleImpressions('incomplete');
	}

	return valid;
}


/**
 * Validate VIN number entered in input field for chassis number.
 */
export function validateVin(vin) {
    let passed = true;

    if (vin.length !== 17) {
        passed = false;
    }

    return passed;
}
